export default __webpack_public_path__ + "52cbf5a84dd84853d66e9133293c6e33.svg";